import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@mui/material';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import TypeIndentityCard from 'shell/components/shared/type-indentity-card';
// import ReleaseReasonIndentityCard from './release-mode';
// import TypePaymentList from 'front-office/components/shared/payment/type-payment';
import MunicipalityList from 'shell/components/shared/municipality-list';
import { noop } from 'shell/utils/noop';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import { AccordionIdentityCardVM } from 'front-office/view-models/registration-id-card';

export interface AccordionRegistrationIdentityCardFormComponentProps {
  form: AccordionIdentityCardVM | undefined;
  values?: AccordionIdentityCardVM;
  onChange: (key: string, value: string) => void;
}

const AccordionRegistrationIdentityCardFormComponent = ({
  form,
}: // onChange,
// values,
AccordionRegistrationIdentityCardFormComponentProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <PmiTextField label="Numero" disabled aria-label="Numero" fullWidth value={form?.number} />
      </Grid>
      <Grid item xs={12} md={4}>
        <TypeIndentityCard label="Tipo" disabled value={form?.type || ''} onChange={noop} />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControlLabel
          control={
            <Checkbox
              id="expatriationBan"
              disabled
              inputProps={{ 'aria-label': 'Interdizione espatrio' }}
            />
          }
          value={form?.expatriationBan}
          label="Interdizione espatrio"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data rilascio"
          value={form?.releaseDate || null}
          disabled
          onChange={noop}
          renderInput={(params) => <PmiTextField {...params} fullWidth helperText="" />}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data scadenza"
          value={form?.expirationDate || null}
          disabled
          onChange={noop}
          renderInput={(params) => <PmiTextField {...params} fullWidth helperText="" />}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data annullamento"
          value={form?.cancellationDate || null}
          onChange={noop}
          disabled
          renderInput={(params) => <PmiTextField {...params} fullWidth helperText="" />}
        />
      </Grid>
      {/* <Grid item xs={12} md={5}>
        <ReleaseReasonIndentityCard
          value={values?.releaseMode || ''}
          onChange={(value) => onChange('releaseMode', value || '')}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TypePaymentList value="" onChange={noop} disabled />
      </Grid> */}
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            id="isConsulateRelease"
            value={form?.isConsulateRelease || 'false'}
            onChange={noop}
          >
            <FormControlLabel
              disabled
              value="false"
              control={<Radio />}
              label="Rilasciata in Italia"
            />
            <FormControlLabel
              disabled
              value="true"
              control={<Radio />}
              label="Rilasciata all'estero"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
      {form?.isConsulateRelease ? (
        <Grid container item spacing={2}>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <PmiTitleDivider>Consolato rilascio</PmiTitleDivider>
          </Grid>
          <Grid item xs={12} md={6}>
            <PmiTextField
              label="Codice consolato"
              aria-label="Codice consolato"
              fullWidth
              value={form?.consulateCode}
              disabled
            />
          </Grid>
        </Grid>
      ) : (
        <Grid container item spacing={2}>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <PmiTitleDivider>Comune rilascio</PmiTitleDivider>
          </Grid>
          <Grid item xs={12} md={7}>
            <MunicipalityList
              label="Comune"
              aria-label="Comune"
              onChange={noop}
              disabled
              value={form?.municipality}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Provincia"
              inputProps={{
                maxLength: '2',
              }}
              aria-label="Provincia"
              fullWidth
              value={form?.municipality?.province}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={7}>
            <PmiTextField
              label="Località"
              aria-label="Località"
              fullWidth
              value={form?.municipality?.description}
              disabled
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

AccordionRegistrationIdentityCardFormComponent.displayName =
  'Accordion cancellation id card form component';

const AccordionRegistrationIdentityCardForm = memo(AccordionRegistrationIdentityCardFormComponent);

export default AccordionRegistrationIdentityCardForm;
